import Vue from 'vue';
import VueGtag from 'vue-gtag';
import { getEnv } from '@gid/vue-common/utils';

export function setupGoogleAnalytics(router) {
  if (getEnv('VUE_APP_GA')) {
    Vue.use(
      VueGtag,
      {
        config: {
          id: getEnv('VUE_APP_GA'),
          params: {
            anonymize_ip: true,
          },
        },
      },
      router,
    );
  }
}
